<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter :orderbutton="true" :listStatus="listStatus" :headers="headers" :viewName="viewName" :orderSummary="orderSummary" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <!-- Dialog xác nhận hủy đơn hàng -->
          <v-dialog v-model="dialogCancelConfirm" max-width="500px">
            <v-card>
              <v-card-title><h3>Xác nhận hủy đơn hàng</h3></v-card-title>
              <v-card-text>
                <p>Bạn có chắc chắn muốn hủy <strong>{{ validOrdersToCancel.length }}</strong> đơn hàng đã chọn?</p>
                <p v-if="invalidOrdersCount > 0" class="red--text">
                  Lưu ý: <strong>{{ invalidOrdersCount }}</strong> đơn hàng không thể hủy (không đủ điều kiện hoặc trạng thái không phù hợp).
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" text @click="dialogCancelConfirm = false">Hủy bỏ</v-btn>
                <v-btn color="red darken-1" dark @click="confirmBulkCancel">Xác nhận hủy đơn</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- Hiển thị các nút: Hủy đơn, Xóa đơn khi người dùng tích chọn danh sách đơn hàng -->
          <v-layout row justify-end pa-2 mr-1 v-if="selectedOrders.length > 0">
            <v-btn color="red darken-1" dark @click="bulk_delete">
              Xóa đơn đã chọn ({{ selectedOrders.length }})
            </v-btn>
            <v-btn color="black darken-1" dark @click="bulk_cancel">
              Hủy đơn đã chọn ({{ selectedOrders.length }})
            </v-btn>
          </v-layout>
                <v-data-table fixed-header height= "65vh" 
                  :headers="headers"
                  :items="orders"
                  :must-sort="true"
                  :options.sync="pagination"
                  :server-items-length="total_rows"
                  :footer-props="items_per_page"
                  :loading="loading"
                  show-select
                  v-model="selectedOrders"
                  item-key="ID" >
                  <template v-slot:item="{ item, isSelected, select}">
                    <tr :active="isSelected">
                      <td @click="select(!isSelected)"><v-checkbox primary hide-details :input-value="isSelected"></v-checkbox></td>
                      <td>{{ item.ID }}</td>
                      <td>
                        <v-img :lazy-src="proxyImage(decodeURIComponent(item.image_origin))" :src="proxyImage(decodeURIComponent(item.image_origin))" width="64px" height="64px"></v-img>
                      </td>
                      <td class="text-end">{{ item.TotalAmountCNY | currency('¥', 2)}}</td>
                      <td class="text-end font-weight-bold">{{ item.TotalAmountVND | currency}}</td>
                      <td class="text-end">{{ item.RemainingAmountVND | currency}}</td>
                      <td v-if="orderRole & 1">
                        <a target="_blank" :href="'khach-hang/quan-ly-khach-hang/' + item.UID">{{ item.CustomerName }}</a>
                      </td>
                      <td v-else>
                        {{ item.CustomerName }}
                      </td>
                      <td v-if="orderRole & 512">
                        <v-edit-dialog
                          :return-value.sync="item.BuyerName"
                          large
                          lazy
                          persistent
                          @save="saveStaff(item.ID, item.BuyerID, item.CSID)"
                        >
                          <div>{{ item.BuyerName }}</div>
                          <template v-slot:input>
                            <v-select
                              :items="p_staffs"
                              v-model="item.BuyerID"
                              item-text="FullName"
                              item-value="ID"
                              v-on:change="item.BuyerName = getStaffName(item.BuyerID)"
                            ></v-select>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td v-if="!(orderRole & 512)">
                        {{ item.BuyerName }}
                      </td>
                      <td v-if="(orderRole & 1024)">
                        <v-edit-dialog
                          :return-value.sync="item.CSName"
                          large
                          lazy
                          persistent
                          @save="saveStaff(item.ID, item.BuyerID, item.CSID)"
                        >
                          <div>{{ item.CSName }}</div>
                          <template v-slot:input>
                            <v-select
                              :items="cs_staffs"
                              v-model="item.CSID"
                              item-text="FullName"
                              item-value="ID"
                              v-on:change="item.CSName = getStaffName(item.CSID)"
                            ></v-select>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td v-if="!(orderRole & 1024)">
                        {{ item.CSName }}
                      </td>
                      <td>
                        {{ item.CreatedDate | display_date('DD-MM-YYYY')}}
                        <br />
                        {{ item.CreatedDate | display_date('HH:mm:ss')}}
                      </td>
                      <td class="truncate">{{ item.Note }}</td>
                      <td v-if="item.SignalPackageStatus != 1">
                        
                      </td>
                      <td v-if="item.SignalPackageStatus == 1">
                        {{ item.SignalDatePackage | display_date('DD-MM-YYYY')}}
                        <br />
                        {{ item.SignalDatePackage | display_date('HH:mm:ss')}}
                      </td>
                      <td>
                        <a 
                        target="_blank" 
                        :href="'/don-hang/' + item.ID"
                        class="v-btn v-btn--block v-btn--depressed v-btn--flat v-btn--outlined theme--dark v-size--small" 
                        v-bind:style="{'color': get_order_status_color(item.Status), 'caret-color': get_order_status_color(item.Status)} ">{{ item.Status | order_status}}</a>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import Filtering from "@/components/Filtering";
import { proxyImage, sendErrorNotice, sendSuccessNotice } from "@/commons/utils";
export default {
  components: {
    "hpo-filter": Filtering
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      proxyImage: proxyImage,
      search: "",
      selectedOrders: [],
      dialogCancelConfirm: false,
      headers: [
        {
          text: "Order ID",
          value: "ID",
          filterable: true,
          quickSearch: true,
          dataType: dataType["Number"]
        },
        {
          text: "Ảnh SP",
          value: "image_origin",
          sortable: false,
          filterable: false,
          dataType: dataType["String"]
        },
        {
          text: "Tổng tệ",
          value: "TotalAmountCNY",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tổng tiền",
          value: "TotalAmountVND",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Còn thiếu",
          value: "RemainingAmountVND",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "User đặt hàng",
          value: "CustomerName",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Nhân viên đặt hàng",
          value: "BuyerName",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Hỗ trợ khách hàng",
          value: "CSName",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Ngày đặt hàng",
          value: "CreatedDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Ghi chú",
          value: "Note",
          quickSearch: true,
          filterable: true,
          width: "150px",
          dataType: dataType["String"]
        },
        {
          text: "Ký nhận",
          value: "SignalPackageStatus",
          filterable: true,
          sortable: true,
          dataType: dataType["Enum"],
          values: configs.SIGNAL_TYPE
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          dataType: dataType["Enum"],
          values: configs.ORDER_STATUS
        }
      ],
      pagination: _.cloneDeep(configs.PAGINATION),
      menu_items: configs.ORDER_MENU,
      selectedTab: 0,
      items: ["All", "Menu1", "Menu2", "Menu3"],
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      listStatus: _.filter(configs.ORDER_STATUS, s => s.value !== configs.ORDER_STATUS_ENUM.hoan_thanh),
      viewName: "order_list",
      filterConditions: [],
      quickFilterConditions: [],
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
        this.filter_data();
      },
      deep: true
    },
    selectedTab: function(val) {
      //this.filter_data();
    }
  },
  computed: {
    ...mapState({
      orders: state => state.main_order.all.data,
      orderSummary: state => state.main_order.all.summary,
      total_rows: state => state.main_order.all.total,
      loading: state => state.main_order.loading,
      staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return ((o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase) || ((o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService);
        }),
      p_staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return (o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
        }),
      cs_staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return (o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
        })
    }),
    pages() {
      return Math.ceil(
        this.total_rows / this.options.itemsPerPage
      );
    },
    orderRole() {
      return this.$store.state.authentication.role.Orders;
    },
    isAdmin() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    validOrdersToCancel() {
      return this.selectedOrders.filter(order => 
        order.Status == configs.ORDER_STATUS_ENUM.da_dat_coc || 
        order.Status == configs.ORDER_STATUS_ENUM.cho_dat_coc || 
        this.isAdmin
      );
    },
    invalidOrdersCount() {
      return this.selectedOrders.length - this.validOrdersToCancel.length;
    },
  },
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.selectedOrders = [];
      this.$store.dispatch("main_order/getListOrders", param);
    },
    gotoDetail: function(id) {
      let routeData = this.$router.resolve({
        name: "OrderDetail",
        params: {
          Pid: id,
          title: `Chi tiết đơn hàng (#${id})`
        }
      });
      window.open(routeData.href, "_blank");
    },
    getStaffName(staffId) {
      const staff = _.find(this.staffs, {
        ID: staffId
      });
      return staff ? staff.FullName : "";
    },
    saveStaff(orderId, buyerId, csId) {
      const updateInfo = {
        OrderID: orderId,
        CustomerServiceID: csId,
        BuyerID: buyerId
      };
      this.$store.dispatch("main_order/updateOrderDetail", updateInfo);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    get_order_status_color(value){
      const objStatus = configs.ORDER_STATUS.find(obj => obj.value === value);
      return objStatus ? objStatus.color : 'black';
    },
    bulk_delete() {
      window.getApp.$emit('REQUEST_BULK_DELETE', this.selectedOrders.map((item) => {if(item.Status == 0 || item.Status == 3 || item.Status == 1) return item.ID;}), 'order');
    },
    bulk_cancel() {
      if (this.selectedOrders.length === 0) {
        sendErrorNotice('Vui lòng chọn ít nhất một đơn hàng!');
        return;
      }
      
      if (this.validOrdersToCancel.length === 0) {
        sendErrorNotice('Không có đơn hàng nào có thể hủy!');
        return;
      }
      
      this.dialogCancelConfirm = true;
    },
    async confirmBulkCancel() {
      this.dialogCancelConfirm = false;
      
      const orderIds = this.validOrdersToCancel.map(order => order.ID);
      
      try {
        // Hủy từng đơn hàng
        const promises = orderIds.map(orderId => 
          this.$store.dispatch('main_order/updateOrderDetail', {
            OrderID: orderId,
            Status: configs.ORDER_STATUS_ENUM.huy
          })
        );
        
        await Promise.all(promises);
        
        sendSuccessNotice(`Đã hủy thành công ${orderIds.length} đơn hàng!`);
        
        // Reset danh sách đã chọn và refresh data
        this.selectedOrders = [];
        this.filter_data();
      } catch (error) {
        sendErrorNotice('Có lỗi xảy ra khi hủy đơn hàng!');
      }
    }
  },
  created() {
    this.$store.dispatch("commons/getAllUsers");
  },
  mounted() {
    this.filterConditions = [];
    this.quickFilterConditions = [];
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>
